export enum FinnovaCodeColumn {
    SALUTATION = 'ANREDE_CD',
    CIVIL_STATUS = 'ZIVILSTAND_CD',
    PROPERTY_REGIME = 'GUETSTAND_CD',
    CONTRACT_TYPE = 'VT_TYP_CD',
    AUTHORIZATION_TYPE = 'SB_SIGN_RECHT_CD',
    RELATIONSHIP_TYPE = 'KD_KD_ART_CD',
    RUBRIK_TYPE = 'KT_RUBRIK_CD',
    ADDRESS_TYPE = 'KD1ADR_T',
}
